var translation = {
	Navatar: {
		header: "Perfil de AWS",
		subheader: "Su perfil contribuye a mejorar sus interacciones con determinadas experiencias de AWS.",
		profileButtonText: "Ver perfil",
		logOutText: "Cerrar sesión",
		logInText: "Acceso",
		createProfileText: "Crear perfil",
		federateLoginModalTitle: "Utiliza Midway para acceder a tu perfil de AWS",
		federateLoginModalFirstDescription: "Como empleado de Amazon, te recomendamos usar Midway para acceder a tu perfil de AWS. Este método, que recomendamos por seguridad, proporciona una integración perfecta con los sistemas internos.",
		federateLoginModalSecondDescription: "Aparece este mensaje porque has iniciado sesión con una dirección de correo electrónico de Amazon con el ID de creador de AWS. Esta petición aparecerá cada vez que inicies sesión hasta que cambies a Midway o elijas continuar con tu inicio de sesión actual.",
		federateLoginModalPrimaryButton: "Iniciar sesión con Midway",
		federateLoginModalSecondaryButton: "Continuar con el ID de creador de AWS"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
